<template>
  <fragment>
    <div class="lojas-perfis-container03">
      <h1 class="lojas-perfis-text">Lojas / Usuários / Perfis</h1>
    </div>
    <div class="lojas-perfis-container04">
      <div class="lojas-perfis-container05">
        <div class="lojas-perfis-container06">
          <div class="lojas-perfis-container07">
            <h1 class="lojas-perfis-text01">Perfis de usuário</h1>
          </div>
          <v-btn
            height="45"
            class="lojas-perfis-selecao"
            @click="openModalSelect"
            :loading="$lojas_usuarios.lojas_loading"
          >
            <span class="pessoas-consumidor-text031">Trocar loja</span>
          </v-btn>
          <v-btn
            height="45"
            class="lojas-perfis-navlink button button-bg"
            @click="goToPerfis('new', '')"
          >
            <span class="lojas-perfis-text03">Novo Perfil</span>
          </v-btn>
        </div>
        <div class="lojas-perfis-container08">
          <div class="lojas-perfis-container09">
            <div class="lojas-perfis-container10">
              <label class="lojas-perfis-text04 input-labels">
                Descrição
              </label>
              <v-text-field
                solo
                placeholder="Ex: Admin"
                v-model="$loja_perfis.filter.descricao"
                type="text"
                class="lojas-perfis-textinput"
              ></v-text-field>
            </div>
            <div class="lojas-perfis-container11">
              <label class="lojas-perfis-text05 input-labels">Loja</label>
              <div class="lojas-perfis-container12">
                <v-select
                  height="48"
                  :items="$loja_perfis.lojas"
                  item-text="nome_loja"
                  item-value="sequenciador"
                  dense
                  solo
                  data-cy="lojas"
                  class="lojas-perfis-textinput1"
                  v-model="$loja_perfis.filter.loja"
                  placeholder="ATIVO"
                ></v-select>
              </div>
            </div>
            <div class="lojas-perfis-container13">
              <v-btn
                height="45"
                class="lojas-perfis-button button button-bg"
                @click="$loja_perfis.filtroPerfis()"
              >
                <span class="lojas-perfis-text06"> Filtrar </span>
              </v-btn>
            </div>
          </div>
          <div class="lojas-perfis-container14">
            <div class="lojas-perfis-container15">
              <label class="lojas-perfis-text08 input-labels">
                Data inicial do cadastro
              </label>
              <div class="lojas-perfis-container16">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dtInicial"
                      :prepend-icon="$config.icons.calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      solo
                      class="lojas-perfis-textinput2"
                      :placeholder="placeholderData"
                      :color="$config.dados.corinputs"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="$loja_perfis.filter.dataInicio"
                    :active-picker.sync="activePicker"
                    :max="
                      new Date(
                        Date.now() - new Date().getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    min="1950-01-01"
                    @change="save"
                    locale="pt"
                    :header-color="$config.dados.corinputs"
                    landscape
                    :color="$config.dados.corinputs"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="lojas-perfis-container17">
              <label class="lojas-perfis-text09 input-labels">
                Data final do cadastro
              </label>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dtFinal"
                    :prepend-icon="$config.icons.calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    class="lojas-perfis-textinput3"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="$loja_perfis.filter.dataFim"
                  :active-picker.sync="activePicker2"
                  :max="
                    new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substr(0, 10)
                  "
                  min="1950-01-01"
                  @change="save2"
                  locale="pt"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  landscape
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="lojas-perfis-container18">
              <label class="lojas-perfis-text10 input-labels"> Status </label>
              <v-select
                height="48"
                :items="status"
                dense
                solo
                class="lojas-perfis-textinput4"
                v-model="$loja_perfis.filter.status"
                placeholder="ATIVO"
              ></v-select>
            </div>
          </div>
        </div>
        <div
          class="lojas-perfis-container19"
          v-if="
            $loja_perfis.perfis &&
            $loja_perfis.perfis.length == 0 &&
            !$loja_perfis.cadastro.loading
          "
        >
          <span>Não há perfis de usuários registrados para esta loja.</span>
        </div>
        <v-progress-linear
          indeterminate
          v-else-if="$loja_perfis.cadastro.loading"
          color="#393939"
        >
        </v-progress-linear>
        <div class="lojas-perfis-container19" v-else>
          <v-simple-table fixed-header class="lojas-perfis-container19">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in headers"
                    :key="index"
                    class="text-center table-header"
                  >
                    {{ header.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(perf, index) in $loja_perfis.perfis" :key="index">
                  <td class="text-center">{{ perf.descricao }}</td>
                  <td class="text-center">
                    {{ $config.convertDataBR(perf.ins_dthr.substring(0, 10)) }}
                  </td>
                  <td class="text-center">
                    {{ perf.ativo == 1 ? "SIM" : "NÃO" }}
                  </td>
                  <td class="table-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          x-small
                          dark
                          v-bind="attrs"
                          v-on="on"
                          @click="goToPerfis('edit', perf)"
                          class="lojas-perfis-button01 button button-bg"
                        >
                          <EditIcon />
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          x-small
                          dark
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $loja_perfis.deletarPerfil(perf.idperfil_loja)
                          "
                          class="lojas-perfis-button02 button button-bg"
                        >
                          <DeleteIcon />
                        </v-btn>
                      </template>
                      <span>Deletar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
    <ModalLojasPerfis :show="modalSelectLoja" @update-dialog="openSelectLoja" />
  </fragment>
</template>

<script>
export default {
  name: "Perfis",
  metaInfo: {
    title: "Perfís | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Perfís | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    ModalLojasPerfis: () =>
      import("@/components/lojas/lojas-modal-selecao-perfis.vue"),
    EditIcon: () => import("@/components/icons/EditIcon.vue"),
    DeleteIcon: () => import("@/components/icons/DeleteIcon.vue"),
  },
  data() {
    return {
      modalSelectLoja: false,
      loja: "",
      status: ["ATIVO", "INATIVO"],
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
      dtInicial: "",
      dtFinal: "",
      placeholderData: "dd/mm/aa",
      headers: [
        {
          title: "Descrição",
        },
        {
          title: "Data Cadastro",
        },
        {
          title: "Ativo",
        },
        {
          title: "Ações",
        },
      ],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
    loja(e) {
      this.$loja_perfis.getPerfis(e);
      this.modalSelectLoja = false;
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.dtInicial = this.$config.convertDataBR(date);
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.dtFinal = this.$config.convertDataBR(date);
    },
    goToPerfis(type, data) {
      if (data && data.modulos) {
        let modules = data.modulos.split(";");
        let modulosMontados = [];
        modules.forEach(element => {
          modulosMontados.push({
            key: element,
            value: element.charAt(0) + element.slice(1).toLowerCase(),
          });
        });

        this.$loja_perfis.perfilAddOrEdit = type;
        this.$loja_perfis.cadastro.idperfil = data.idperfil_loja;
        this.$loja_perfis.cadastro.descricao = data.descricao;
        this.$loja_perfis.cadastro.ativo = data.ativo;
        this.$loja_perfis.cadastro.modulo = modulosMontados;
        this.$axios.rota("lojas-perfis-add-edit");
        return;
      }
      this.$loja_perfis.perfilAddOrEdit = type;
      this.$loja_perfis.cadastro.idperfil = data.idperfil_loja;
      this.$loja_perfis.cadastro.descricao = data.descricao;
      this.$loja_perfis.cadastro.ativo = data.ativo;
      this.$loja_perfis.cadastro.modulo = data.modulos;
      this.$axios.rota("lojas-perfis-add-edit");
    },
    openSelectLoja(showDialog) {
      this.modalSelectLoja = showDialog;
    },
    openModalSelect() {
      this.$loja_perfis.lojas_loading = true;
      this.$loja_perfis.loja_selecionada = "";
    },
  },
  beforeMount() {
    // if(!this.$axios.getLocal('loja_selecionada')) {
    this.modalSelectLoja = true;
    // }
  },
  destroyed() {
    this.$loja_perfis.loja_selecionada = "";
    this.$loja_perfis.perfis = [];
  },
};
</script>

<style scoped>
.lojas-perfis-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}

.lojas-perfis-container01 {
  top: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  bottom: 0px;
  height: 100%;
  margin: auto;
  display: flex;
  position: absolute;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-container02 {
  right: 0px;
  width: 100%;
  bottom: 0px;
  height: calc(100% - 80px);
  position: absolute;
  max-height: 1000px;
}

.lojas-perfis-main-perfil {
  right: 0px;
  width: calc(100% - 90px);
  bottom: 0px;
  height: 100%;
  margin: auto;
  display: flex;
  position: absolute;
  max-width: 3000px;
  min-width: 500px;
  align-self: flex-end;
  overflow-x: hidden;
  overflow-y: auto;
  align-items: flex-start;
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 15px;
  justify-content: center;
  background-color: #eaeaea;
}

.lojas-perfis-body-perfil {
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 15px;
  padding-left: 15px;
  border-radius: 20px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 15px;
  background-color: var(--dl-color-gray-white);
}

.lojas-perfis-container03 {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  align-items: flex-start;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-text {
  font-size: 1.2em;
}

.lojas-perfis-container04 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  padding-top: 15px;
  padding-left: 15px;
  border-radius: 20px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 15px;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.lojas-perfis-container05 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-direction: column;
}

.lojas-perfis-container06 {
  flex: 0 0 auto;
  width: 100%;
  height: 60px;
  display: flex;
  position: relative;
  align-items: center;
  padding-left: 5px;
  margin-bottom: 30px;
  padding-right: 5px;
  flex-direction: row;
  justify-content: flex-end;
}

.lojas-perfis-container07 {
  top: 0px;
  flex: 0 0 auto;
  left: 0px;
  width: 200px;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-text01 {
  font-size: 1em;
  align-self: flex-start;
}

.lojas-perfis-selecao {
  color: var(--dl-color-gray-black);
  height: 50px;
  display: flex;
  border-width: 0px;
  margin-right: 20px;
  border-radius: 10px;
  border: 1px solid var(--dl-color-gray-black);
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-white);
}

.lojas-perfis-navlink {
  color: var(--dl-color-gray-white);
  height: 50px;
  display: flex;
  border-width: 0px;
  border-radius: 10px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-text03 {
  align-self: center;
}

.lojas-perfis-container08 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.lojas-perfis-container09 {
  width: 100%;
  height: 100px;
  display: flex;
  align-self: center;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-container10 {
  flex: 0 0 auto;
  width: 33.33%;
  height: 100%;
  display: flex;
  align-items: space-between;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
}

.lojas-perfis-text04 {
  margin-bottom: 6px;
}

.lojas-perfis-textinput {
  height: 51px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.lojas-perfis-container11 {
  flex: 0 0 auto;
  width: 33.33%;
  height: 100%;
  display: flex;
  align-items: space-between;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-text05 {
  margin-bottom: 6px;
}

.lojas-perfis-container12 {
  flex: 0 0 auto;
  width: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.lojas-perfis-textinput1 {
  width: 100%;
  height: 51px;
  border-radius: 10px;
}

.lojas-perfis-container13 {
  flex: 0 0 auto;
  width: 33.33%;
  height: 100%;
  display: flex;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 6px;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-button {
  color: var(--dl-color-gray-white);
  height: 50px;
  display: flex;
  border-width: 0px;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-text06 {
  align-self: center;
}

.lojas-perfis-container14 {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: row;
}

.lojas-perfis-container15 {
  flex: 0 0 auto;
  width: 33.33%;
  height: 100%;
  display: flex;
  align-items: space-between;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-text08 {
  margin-bottom: 6px;
}

.lojas-perfis-container16 {
  flex: 0 0 auto;
  width: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.lojas-perfis-textinput2 {
  width: 100%;
  height: 51px;
  border-radius: 10px;
}

.lojas-perfis-container17 {
  flex: 0 0 auto;
  width: 33.33%;
  height: 100%;
  display: flex;
  align-items: space-between;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-text09 {
  margin-bottom: 6px;
}

.lojas-perfis-textinput3 {
  width: 100%;
  height: 51px;
  border-radius: 10px;
}

.lojas-perfis-container18 {
  flex: 0 0 auto;
  width: 33.33%;
  height: 100%;
  display: flex;
  align-items: space-between;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-text10 {
  margin-bottom: 6px;
}

.lojas-perfis-textinput4 {
  width: 100%;
  height: 51px;
  border-radius: 10px;
}

.lojas-perfis-container19 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.lojas-perfis-container20 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.lojas-perfis-container21 {
  flex: 0 0 auto;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-top-width: 0px;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text11 {
  color: var(--dl-color-gray-white);
}

.lojas-perfis-container22 {
  flex: 0 0 auto;
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text12 {
  color: var(--dl-color-gray-white);
}

.lojas-perfis-container23 {
  flex: 0 0 auto;
  width: 15%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text13 {
  color: var(--dl-color-gray-white);
}

.lojas-perfis-container24 {
  flex: 0 0 auto;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-bottom-width: 2px;
}

.lojas-perfis-text14 {
  color: var(--dl-color-gray-white);
}

.lojas-perfis-container25 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-container26 {
  flex: 0 0 auto;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-top-width: 0px;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container27 {
  flex: 0 0 auto;
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container28 {
  flex: 0 0 auto;
  width: 15%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text17 {
  text-align: center;
}

.lojas-perfis-container29 {
  flex: 0 0 auto;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: row;
  justify-content: center;
  border-bottom-width: 2px;
}

.lojas-perfis-container29:hover {
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-button01 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}

.lojas-perfis-button02 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon02 {
  fill: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
}

.lojas-perfis-container30 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-container31 {
  flex: 0 0 auto;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-top-width: 0px;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container32 {
  flex: 0 0 auto;
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container33 {
  flex: 0 0 auto;
  width: 15%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text20 {
  text-align: center;
}

.lojas-perfis-container34 {
  flex: 0 0 auto;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: row;
  justify-content: center;
  border-bottom-width: 2px;
}

.lojas-perfis-container34:hover {
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-button03 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon04 {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}

.lojas-perfis-button04 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon06 {
  fill: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
}

.lojas-perfis-container35 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-container36 {
  flex: 0 0 auto;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-top-width: 0px;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container37 {
  flex: 0 0 auto;
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container38 {
  flex: 0 0 auto;
  width: 15%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text23 {
  text-align: center;
}

.lojas-perfis-container39 {
  flex: 0 0 auto;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: row;
  justify-content: center;
  border-bottom-width: 2px;
}

.lojas-perfis-container39:hover {
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-button05 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon08 {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}

.lojas-perfis-button06 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon10 {
  fill: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
}

.lojas-perfis-container40 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-container41 {
  flex: 0 0 auto;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-top-width: 0px;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container42 {
  flex: 0 0 auto;
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container43 {
  flex: 0 0 auto;
  width: 15%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text26 {
  text-align: center;
}

.lojas-perfis-container44 {
  flex: 0 0 auto;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: row;
  justify-content: center;
  border-bottom-width: 2px;
}

.lojas-perfis-container44:hover {
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-button07 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon12 {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}

.lojas-perfis-button08 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon14 {
  fill: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
}

.lojas-perfis-container45 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.lojas-perfis-container46 {
  flex: 0 0 auto;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: column;
  justify-content: center;
  border-top-width: 0px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 0px;
}

.lojas-perfis-container47 {
  flex: 0 0 auto;
  width: 35%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-container48 {
  flex: 0 0 auto;
  width: 15%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  flex-direction: column;
  justify-content: center;
  border-right-width: 2px;
  border-bottom-width: 2px;
}

.lojas-perfis-text29 {
  text-align: center;
}

.lojas-perfis-container49 {
  flex: 0 0 auto;
  width: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: solid;
  border-width: 0px;
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: row;
  justify-content: center;
  border-bottom-width: 2px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 20px;
}

.lojas-perfis-container49:hover {
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.lojas-perfis-button09 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon16 {
  fill: var(--dl-color-gray-white);
  width: 20px;
  height: 20px;
}

.lojas-perfis-button10 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-icon18 {
  fill: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
}

@media (max-width: 991px) {
  .lojas-perfis-main-perfil {
    width: 100%;
    margin: auto;
    min-width: 320px;
  }
}

@media (max-width: 767px) {
  .lojas-perfis-container02 {
    width: 100%;
  }

  .lojas-perfis-main-perfil {
    left: 0px;
    width: 100%;
    height: 100%;
    max-width: auto;
    min-width: 320px;
  }
}

@media (max-width: 479px) {
  .lojas-perfis-container01 {
    width: 98%;
  }

  .lojas-perfis-main-perfil {
    width: 98%;
    min-width: 320px;
  }
}
</style>
